export function throttle(func, delay) {
    var inProgress = false;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (inProgress) {
            return;
        }
        inProgress = true;
        setTimeout(function () {
            func.apply(void 0, args);
            inProgress = false;
        }, delay);
    };
}
//# sourceMappingURL=throttle.js.mapexport function throttle(func, delay) {
    var inProgress = false;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (inProgress) {
            return;
        }
        inProgress = true;
        setTimeout(function () {
            func.apply(void 0, args);
            inProgress = false;
        }, delay);
    };
}
//# sourceMappingURL=throttle.js.map